import styled from 'styled-components';
import { Text, Input } from 'v3/components';


export const ChecklistExpiration = styled.div`
	border: 1px solid #ddd;
	border-radius: 4px;
	padding: 8px;
	margin-bottom: 4px;
`;

export const ChecklistExpirationLabel = styled(Text)`
  margin-bottom: 4px;
`;

export const ChecklistExpirationGrid = styled.div`
	display: flex;
	align-items: center;
	gap: 8px;
	flex-wrap: nowrap;
`

export const ChecklistExpirationCondition = styled.label`
  display: flex;
  align-items: center;
  gap: 4px;
  cursor: pointer;
`

export const ChecklistExpirationConditionInput = styled(Input)`
	width: 4rem;
	text-align: center;
`
